import { takeLatest, put, all, call } from 'redux-saga/effects'

import api from '~/services/api'

import {
  Types,
  updateDashboard
} from './actions'

export function * getDashboard ({ payload }) {
  const { campaignId, storeId } = payload

  if (!campaignId || !storeId) yield put(updateDashboard({ error: 'Ocorreu um erro ao processar a requisição' }))

  const url = `/campaign/${campaignId}/stores/${storeId}/dashboard/store`

  try {
    const response = yield call(
      api.get,
      url
    )

    if (response.status === 200) {
      if (response.data.success && response.data?.data && response.data.data.length > 0) {
        yield put(updateDashboard({ dashboardData: response.data.data[0] }))
      } else {
        yield put(updateDashboard({ error: response?.data?.errors[0] || response.data.message }))
      }
    } else {
      yield put(updateDashboard({ error: 'Ocorreu um erro ao processar a requisição' }))
    }
  } catch (error) {
    yield put(updateDashboard({ error: error.message }))
  }
}

export default all([
  takeLatest(Types.getDashboard, getDashboard)
])
